import React, { ReactElement } from 'react';
import {
  MessageBar,
  MessageBarType,
} from "@fluentui/react";
import { useWarningMessage } from './WarningMessageProvider';
import { mergeStyleSets } from '@fluentui/react';
import { Constants } from '../../shared/Constants/Constants';

const myStyles = mergeStyleSets({
  warningContent: {
    position: 'fixed',
    top: 48,
    left: '260px',
    width: 'calc(100% - 260px)',
    zIndex: 1001
  },
  mobileWarningContent: {
    position: 'fixed',
    top: 48,
    width: '100%',
    zIndex: 1001
  }
});

export function WarningMessageBar(): ReactElement {
  const { warnings, removeWarning } = useWarningMessage();
  const [isMobile, setIsMobile] = React.useState(false);

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= Constants.MOBILE_BREAKPOINT_WIDTH);
    };
    // Set initial value immediately
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (warnings.length === 0) {
    return <></>;
  }

  // Display the first warning
  const warning = warnings[0];

  return (
    <div
      className={isMobile ? myStyles.mobileWarningContent : myStyles.warningContent}
      role="alert"
      aria-label={warning.title}
    >
      <MessageBar messageBarType={MessageBarType.warning} onDismiss={() => removeWarning(warning.id)}>
        <strong>{warning.title}</strong>
        <div>{warning.message}</div>
      </MessageBar>
    </div>
  );
}